// LEGACY_NAME: ygi-learn-article
import React, { PropsWithChildren } from 'react';

import { LearnArticleContent, LearnArticleMain } from './elements';

interface LearnArticleProps {
  content: React.ReactNode;
  preContent?: React.ReactNode;
}

export const LearnArticle: React.FC<PropsWithChildren<LearnArticleProps>> = ({
  content,
  preContent,
  children,
}) => (
  <LearnArticleMain id="content">
    {preContent}
    <LearnArticleContent>{content}</LearnArticleContent>
    {children}
  </LearnArticleMain>
);
